import React, { useContext, useEffect, useState } from 'react';
import './Header.scss';
import { ReactComponent as Rover } from '../../assets/img/mars-rover.svg';
import clsx from 'clsx';
import { FilterStore } from '../../App';

export default ({ small = false }) => {

  const [isSmall, setIsSmall] = useState(small);

  const { firstFetched } = useContext(FilterStore).filter;

  useEffect(() => {
    if (firstFetched) {
      setIsSmall(true);
    }
  }, [firstFetched]);

  return (
    <header className="header">
      <h1 className={clsx({
        'header__headline': true,
        'header__headline--small': isSmall
      })}>rover organizer</h1>
      <Rover className={clsx({
        'header__logo': true,
        'header__logo--small': isSmall
      })} />
    </header>
  )
};